/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { SecurityHelper } from 'sarsaparilla';
import * as globals from '../constants/globals';
import { makeAsyncAction } from '../utils/async_utils';
import {
    POST_REVIEW_VOTE_FAILURE,
    POST_REVIEW_VOTE_START,
    POST_REVIEW_VOTE_SUCCESS,
} from '../constants/types';

export type voteRequest = {
    id?: string;
    reservation_id?: string;
    is_helpful: boolean;
    vote_changed: boolean;
};

export const postReviewVoteEndpoint = () => `${globals.API_URL}/helpful/vote`;

const postReviewVoteApi = (data: voteRequest) => () =>
    axios.post(postReviewVoteEndpoint(), data, {
        headers: { Authorization: SecurityHelper.getAuthHeader() },
    });

export const postReviewVote = makeAsyncAction(
    {
        startType: POST_REVIEW_VOTE_START,
        successType: POST_REVIEW_VOTE_SUCCESS,
        failureType: POST_REVIEW_VOTE_FAILURE,
    },
    postReviewVoteApi,
    true,
    'data'
);
